import React from 'react';

const SvgIconZoomOut = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M20 10.75a1 1 0 011 1v.5a1 1 0 01-1 1H4a1 1 0 01-1-1v-.5a1 1 0 011-1z" />
  </svg>
);

export default SvgIconZoomOut;
